export const BOOLEAN_OPTIONS = [
  { label: 'Oui', value: true },
  { label: 'Non', value: false },
] as const

export const NEWSLETTER_OPTIONS = [
  { label: 'Oui, je souhaite recevoir les offres', value: 'YES' },
  { label: 'Non merci', value: 'NO' },
  { label: 'Déjà inscrit', value: 'ALREADY_SUBSCRIBED' },
] as const

export { GENDER_LABELS_TITLE as GENDER_LABELS } from '@/utils/gender-labels'

export const GENDER_COLORS: Record<string, string> = {
  FEMALE: 'from-rose-400 to-pink-500',
  MALE: 'from-blue-400 to-indigo-500',
}
